import adminProductService from '../db/admin-product-service';

export const bulkUpdateProductsWithCardFields = async () => {
  try {
    console.log('Starting bulk update of products with card fields...');
    
    const allProducts = await adminProductService.getAllProducts(true);
    let updatedCount = 0;
    let errorCount = 0;

    for (const product of allProducts) {
      try {
        // Only update if card fields are missing
        if (!product.cardBenefit && !product.cardPackageInfo && !product.cardKeyFeatures) {
          const updatedProduct = {
            ...product,
            cardBenefit: product.cardBenefit || 'Premium Product',
            cardPackageInfo: product.cardPackageInfo || `${product.unit || 'unit'} available`,
            cardKeyFeatures: product.cardKeyFeatures || 'Quality assured',
            highlights: product.highlights || '',
            ingredients: product.ingredients || '',
            usageInstructions: product.usageInstructions || '',
            storageInstructions: product.storageInstructions || '',
            certifications: product.certifications || ''
          };

          await adminProductService.updateProduct(product._id, updatedProduct);
          console.log(`✓ Updated: ${product.name}`);
          updatedCount++;
        }
      } catch (err) {
        console.error(`✗ Error updating ${product.name}:`, err);
        errorCount++;
      }
    }

    console.log(`\nBulk update complete!`);
    console.log(`Updated: ${updatedCount} products`);
    console.log(`Errors: ${errorCount} products`);
    
    return { updatedCount, errorCount };
  } catch (err) {
    console.error('Bulk update failed:', err);
    throw err;
  }
};

export default bulkUpdateProductsWithCardFields;
